var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PersonelIoInfoInDateListWeb"},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.list,"hide-default-footer":!_vm.pagination,"disable-pagination":!_vm.pagination,"footer-props":{
      'items-per-page-options': [5, 10, 15, 50, 100, -1],
      'items-per-page-text': _vm.$t('rowsPerPage'),
      'show-first-last-page': true,
    },"item-class":_vm.getItemClass},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.Duration",fn:function(ref){
    var item = ref.item;
return [_c('div',{class:[_vm.getDurationClass(item), 'd-flex w-100 h-100']},[_c('span',{staticClass:"my-auto px-1"},[_vm._v(_vm._s(item.Duration))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }